import { lazy } from 'react';

import { metaAdsTranslations as enMetaAds } from '@/lang/en/metaAds';
import { metaAdsTranslations as esMetaAds } from '@/lang/es/metaAds';
import { metaAdsTranslations as ptMetaAds } from '@/lang/pt/metaAds';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const MetaAdsNavigation = lazy(() =>
  import('./MetaAdsNavigation').then((m) => ({ default: m.MetaAdsNavigation })),
);

// Connection settings for the Meta Ads account live under /app/settings.
const MetaAdsSettingsPage = lazy(
  () => import('@/app/core/app/settings/integrations/meta-ads/presentation/MetaAdsPage'),
);

/** Meta Ads campaign reporting plus its account-connection settings page. */
export const metaAdsModule: FeatureModule = {
  id: 'meta-ads',
  routes: [{ path: 'meta-ads/*', to: '/app/meta-ads', Component: MetaAdsNavigation }],
  settingsRoutes: [
    {
      path: 'integrations/meta-ads',
      to: '/app/settings/integrations/meta-ads',
      Component: MetaAdsSettingsPage,
    },
  ],
  nav: [
    {
      sectionId: 'main',
      order: 60,
      to: '/app/meta-ads',
      label: label('global', 'sidebar_meta_ads_label'),
    },
  ],
  i18n: namespaceBundle('metaAds', { es: esMetaAds, en: enMetaAds, pt: ptMetaAds }),
};
